module.exports = __webpack_public_path__ + "static/media/zland.badda042.jpg";